import React from "react";

const AboutUs = () => {
  return (
    <div className="p-10">
      <h1 className="text-3xl font-bold">AboutUs</h1>
      <p className="mt-4 text-gray-600">
        About Us At Pronttera, we are a dynamic and health-centric company
        dedicated to building innovative solutions, primarily in the hospitality
        sector. Our core focus lies in developing health-based products that
        enhance efficiency, safety, and overall well-being. However, our
        expertise extends far beyond health—we have successfully delivered
        projects in finance, e-commerce, and various other industries,
        demonstrating our ability to adapt and innovate across different
        domains. We believe in turning ideas into reality, offering cutting-edge
        technology services tailored to meet the unique needs of businesses,
        from startups to enterprises. Guided by our motto, "Your vision, our
        competence," we take pride in our ability to develop anything and
        everything. Whether it’s building complex systems, designing scalable
        applications, or providing end-to-end solutions, we are committed to
        delivering excellence. Beyond our technology and service offerings, we
        are also deeply invested in education. Pronttera Labs
        (edu.pronttera.com) serves as our educational extension, where we train
        and mentor aspiring engineers through expert-led courses. Our goal is to
        bridge the gap between learning and real-world application, empowering
        the next generation of tech professionals with the knowledge and skills
        they need to succeed. At Pronttera, we don’t just build products—we
        build the future.
      </p>
    </div>
  );
};

export default AboutUs;
